import cx from 'classnames';
import { ADMIN_USER, AUTHOR, TOPIC_MODERATOR } from 'mk/autogenerated/translations/CommentHeaderName.43e5e6d7cc6b8f1cbf3c333aa94743e0'
import { authorIsModerator } from 'mk/bazaar/common/userUtils';
import { CommentEntity } from 'mk2/apps/blogs/schemas';
import { CounsellingUserChip } from 'mk2/apps/forum/components/CounsellingUserChip';
import { UserChip } from 'mk2/apps/forum/components/UserChip';
import { CounsellingEntity } from 'mk2/apps/forum/schemas';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './CommentHeaderName.mscss';

interface OwnProps {
    comment: CommentEntity;
    inForum: boolean;
    inGroups: boolean;
    moderators: UserEntity[];
    counselling: CounsellingEntity;
}

type Props = OwnProps;

class CommentHeaderName extends React.PureComponent<Props> {
    public render() {
        const { comment, counselling, inForum, inGroups, moderators } = this.props;

        const isPostAuthor =
            !comment.byAdmin && comment.authorUser.username === comment.targetOwner.username;
        const authorIsTopicModerator =
            (inForum || inGroups) &&
            !comment.byAdmin &&
            moderators &&
            authorIsModerator(comment.authorUser, moderators);

        return (
            <>
                {comment.byAdmin ? (
                    <>
                        <strong
                            className={cx(
                                styles.CommentHeaderName__author,
                                styles['CommentHeaderName__author--byAdmin'],
                            )}
                        >
                            {ADMIN_USER}
                        </strong>{' '}
                    </>
                ) : counselling ? (
                    // don't show author data for counselling, show counselling specific data
                    <CounsellingUserChip counselling={counselling} />
                ) : (
                    <UserChip
                        user={comment.authorUser}
                        size={inForum ? 24 : 32}
                        showAvatar={inForum}
                        spaceBetween={4}
                        boldUsername
                    />
                )}
                {isPostAuthor && (
                    <span
                        className={cx(
                            styles.CommentHeaderName__badge,
                            styles.CommentHeaderName__badgeAuthor,
                        )}
                    >
                        {AUTHOR}
                    </span>
                )}
                {authorIsTopicModerator && (
                    <span
                        className={cx(
                            styles.CommentHeaderName__badge,
                            styles.CommentHeaderName__badgeModerator,
                        )}
                    >
                        {TOPIC_MODERATOR}
                    </span>
                )}
            </>
        );
    }
}

export default CommentHeaderName;
